import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import api from './api-client'
import notify from './notifications-helper'
import Spinner from './spinner'

export const UpdatePlaidWebhooks = () => {
  const [saving, setSaving] = useState(false)
  const dispatch = useDispatch()

  return (
    <button
      type="button"
      className="btn btn-danger"
      disabled={saving}
      onClick={() => {
        const proceed = window.confirm([
          'This will call Plaid itemWebhookUpdate for every linked Plaid account,',
          'pointing each item at the new /api/plaid/webhook URL for that user.',
          'It may take a while. Proceed?'
        ].join(' '))

        if (!proceed) return

        setSaving(true)
        api.updateAllPlaidWebhooks().then(() => {
          dispatch(notify.success({
            message: 'Server received the request and is processing in the background; check logs for progress.'
          }))
        }).catch((ex) => {
          console.error(ex)
          dispatch(notify.error({ message: 'Failed to start Plaid webhook update.' }))
        }).finally(() => {
          setSaving(false)
        })
      }}
    >
      Update ALL Plaid Webhooks {saving && <Spinner />}
    </button>
  )
}

export default UpdatePlaidWebhooks
